.box {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--beigedarker);
  cursor: pointer;
  padding: 2em 1.25em 1.25em;
  position: relative;
  border-radius: 0.75em;
  transition-property: transform, background-color, box-shadow;
  transition-duration: .2s;
  transition-timing-function: ease;

  transform: scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  background-color: white;
  background-size: cover;
  background-position: center;
  align-items: center;
  

  // no zoom on hover: the content of the box stays as it is
  &:hover {
    background-color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  }

  h3,
  .subtitle {
    text-align: center;
  }

  h3 {
    margin-bottom: 0.75em;
  }

  img {
    width: fit-content;
  }
  button {
    margin-top: 1.25em;
    text-align: center;
    justify-content: center;
    cursor: pointer;
  }

  &.active {
    background-color: white;

    z-index: 10;
    transform: scale(1);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);


    .checkbox {

      transform: scale(1);

      &::after {
        opacity: 1;
        transform: scale(1);
      }


    }

  }

  .icon {
    position: absolute;
    top: 1.25em;
    right: 1.25em;
  }

  hr {
    width: 100%;
  }
}

.header {

  display: flex;
  width: 100%;

  h3 {
    flex-grow: 1;
  }

  &.checkboxLeft {
    flex-direction: row-reverse;

    // as much room on the right as the checkbox takes on the left: the title stays centered in the box
    h3 {
      padding-right: 28px;
    }

    .checkbox {
      flex-shrink: 0;
      right: 5px;
    }
  }
}


.checkbox {
  position: relative;
  top: -15px;
  right: -5px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #fff;
  border: 2px solid var(--beigedarker);
  display: flex;
  align-items: center;
  justify-content: center;
  transition-property: transform;
  transition-duration: 0.2s;
  transition-timing-function: ease;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

  &::after {
    content: "✓";
    font-size: 40px;
    color: #4caf50;
    position: relative;
    transition: all 0.3s ease;
    transition-property: opacity, transform;
    transition-duration: 0.2s;
    transition-timing-function: ease;

    transform: scale(0);
    opacity: 0;

    top: -10px;
    left: 3px;
  }
}